import {VersionVariants} from '@jobseeker/lotus/enums';
import type {DialogBoxProps} from './type';
import V1 from './V1';
import V2 from './V2';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;

const JobList = (props: DialogBoxProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default JobList;
